<template>
  <card id="perfil">
    <div slot="header" class="row align-items-center">
      <div class="col-8">
        <h3 class="mb-0">Perfil de usuario</h3>
      </div>
      <div class="col-4 text-right">
        <base-button type="primary" size="sm" @click="sendForm" ><i class="fas fa-save"></i>  Guardar</base-button>
      </div>
    </div>

    <form @submit.prevent="updateProfile">
      <h6 class="heading-small text-muted mb-4">Información de usuario</h6>

      <div class="pl-lg-4">
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="text"
              label="Nombre"
              placeholder="Ingrese como desea ser llamado"
              v-model="user.name"
            >
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              type="email"
              label="Email"
              name="email"
              :error="getError('email')"
              v-validate="'required|email'"
              placeholder="Ingrese su correo electrónico"
              v-model="user.email"
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="password"
              label="Contraseña"
              name="password"
              placeholder="Ingrese una contraseña"
              :error="getError('password')"
              v-validate="reglasPassword"
              ref="contraseña"
              :disabled="change_password=='0'"
              v-model="user.password"
            >
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              type="password"
              label="Confirmar Contraseña"
              name="confirmar"
              placeholder="Confirme su contraseña"
              v-model="user.password_confirmation"
              :error="getError('confirmar')"
              :disabled="change_password=='0'"
              v-validate="reglasConfirmacion"
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
              <base-radio ref="cambiar" name="0" class="mb-3" v-model="change_password">
                  Mantener Contraseña
              </base-radio>
          </div>
          <div class="col-md-4">
              <base-radio ref="cambiar" name="1" class="mb-3" v-model="change_password">
                  Nueva Contraseña
              </base-radio>
          </div>
        </div>
      </div>
      <hr class="my-4">

      <!-- Address -->
      <h6 class="heading-small text-muted mb-4">Información de contacto</h6>

      <div class="pl-lg-4">
        <div class="row">
          <div class="col-md-12">
            <base-input
              type="text"
              label="Dirección"
              placeholder="Domicilio"
              v-model="user.direccion"
            >
            </base-input>
          </div>
        </div>
        <div class="row" v-show="$store.state.user.pais_sponsor == 'Chile'">
          <div class="col-lg-4">
            <base-input label="Región:"
                        :name="'Región'"
                        v-model="user.region"
                          >
                <el-select  @change="updateComunas" v-model="user.region" filterable
                            placeholder="Seleccione región:"
                            >
                    <el-option v-for="option in dataRegiones"
                                :key="option.region"
                                :label="option.region"
                                :value="option.region">
                    </el-option>
                </el-select>
            </base-input>
          </div>
          <div class="col-lg-4">
            <base-input label="Comuna:"
                        :name="'Comuna'"
                        v-model="user.comuna"
            >
                <el-select  v-model="user.comuna" filterable
                            placeholder="Seleccione comuna:"
                            
                            >
                    <el-option v-for="option in comunasList"
                                :key="option"
                                :label="option"
                                :value="option">
                    </el-option>
                </el-select>
            </base-input>
          </div>
          <div class="col-lg-4">
            <base-input
              label="Código postal"
              placeholder="Código postal"
              v-model="user.codigo_postal"
            >
            </base-input>
          </div>
        </div>
      </div>

      <hr class="my-4">
      <!-- Description -->
      <h6 class="heading-small text-muted mb-4">Sobre mí</h6>
      <div class="pl-lg-4">
        <div class="form-group">
          <label class="form-control-label">Sobre mí</label>
          <textarea v-model="user.sobre_mi" rows="4" class="form-control" placeholder="Algunas palabras sobre ti..."></textarea>
        </div>
      </div>
      
    </form>
  </card>
</template>
<script>
import { Select, Option } from 'element-ui';

export default {
  components: {
      [Select.name]: Select,
      [Option.name]: Option,
  },
  data() {
    return {
      validated: false,
      user: {
        company: 'Creative Code Inc.',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        direccion: '',
        region: '',
        comuna: '',
        codigo_postal: '',
        sobre_mi: ``
      },
      change_password: "0",
      reglasConfirmacion: '',
      reglasPassword: '',
      dataRegiones: [],
      comunasList: [],
    };
  },
  methods: {
    updateProfile() {
      alert('Your data: ' + JSON.stringify(this.user));
    },
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
        //throw new Error('hno ke wea esta wea');
      } catch {
        console.log('Oh, tengo ke caputar algo');
        return false;
      }
      finally {
        this.validated = true;
      }
    },
    getError(name){
      return this.errors.first(name)
    },
    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
    updateComunas(){
        this.user.comuna = '';
        this.comunasList = this.dataRegiones.find( elem => elem.region == this.user.region ).comunas;
    },
    sendForm(){
      var vm = this;
      this.firstFormSubmit().then( response => {
        console.log('retorno promesa de validacion', response);
        if( response ){
          vm.axios({
            url: 'api/user',
            method: 'PUT',
            data: {
              email: vm.user.email,
              nombre: vm.user.name,
              direccion: vm.user.direccion,
              region: vm.user.region,
              comuna: vm.user.comuna,
              codigo_postal: vm.user.codigo_postal,
              sobre_mi: vm.user.sobre_mi,
              contraseña: vm.user.password,
              contraseña_confirmation: vm.user.password_confirmation,
              change_password: vm.change_password
            }
          }).then( response => {
            vm.$store.dispatch("retrieveUser").then( response => {
              vm.$notify({
                type: 'success',
                message: 'Información actualizada correctamente'
              });
              vm.$router.push('/pages/user');
            });
            
          }).catch( error => {
            if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
            }else{
              vm.$notify({
                type: 'danger',
                message: 'No se pudo actualizar la información del usuario. Intentelo de nuevo mas tarde.'
              }); 
            }
            
          });
        }
      });
    },
  },
  watch: {
      change_password(value)
      {
          if(this.change_password == '0'){
              this.user.password = '';
              this.user.password_confirmation = '';
              this.reglasPassword = ''
              this.reglasConfirmacion = '';
          } else {
              this.reglasPassword = 'required|min:6';
              this.reglasConfirmacion = 'required|min:6|confirmed:contraseña'
          }
      }
  },
  mounted()
  {
    console.log(this.$store.state.user);
    this.user.name = this.$store.state.user.name;
    this.user.email = this.$store.state.user.email;
    this.user.direccion = this.$store.state.user.address || '';
    this.user.region = this.$store.state.user.region || '';
    this.user.comuna = this.$store.state.user.comuna || '';
    this.user.codigo_postal = this.$store.state.user.zip_code || '';
    this.user.sobre_mi = this.$store.state.user.about_me || '';
  },
  created()
  {
    this.dataRegiones = require("./regiones.json");
  }
};
</script>
<style></style>
